import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const FINANCE_STATUS_LABELS = {
    em_aberto: "Em aberto",
    parcial: "Parcial",
    paga: "Paga",
    vencida: "Vencida",
    cancelada: "Cancelada",
};

export const FINANCE_STATUS_CLASSES = {
    em_aberto: "bg-muted text-foreground border border-border",
    parcial: "bg-amber-100 text-amber-900 border border-amber-300 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/40",
    paga: "bg-emerald-100 text-emerald-900 border border-emerald-300 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/40",
    vencida: "bg-red-100 text-red-900 border border-red-300 dark:bg-red-500/15 dark:text-red-300 dark:border-red-500/40",
    cancelada: "bg-muted text-muted-foreground line-through border border-border",
};

export const PAYMENT_METHOD_LABELS = {
    pix: "PIX",
    dinheiro: "Dinheiro",
    cartao: "Cartão",
    boleto: "Boleto",
    transferencia: "Transferência",
};

export const CATEGORY_LABELS = {
    servicos: "Serviços",
    pecas: "Peças",
    manutencao: "Manutenção",
    salarios: "Salários",
    impostos: "Impostos",
    outros: "Outros",
};

export function FinanceStatusBadge({ status, className, ...props }) {
    const label = FINANCE_STATUS_LABELS[status] || status || "—";
    const cls = FINANCE_STATUS_CLASSES[status] || FINANCE_STATUS_CLASSES.em_aberto;
    return (
        <Badge
            variant="outline"
            className={cn("font-medium", cls, className)}
            data-testid={`finance-status-badge-${status || "unknown"}`}
            {...props}
        >
            {label}
        </Badge>
    );
}

export function daysBetween(a, b) {
    if (!a || !b) return null;
    const da = a instanceof Date ? a : new Date(a);
    const db = b instanceof Date ? b : new Date(b);
    const diff = (db.setHours(0, 0, 0, 0) - da.setHours(0, 0, 0, 0)) / 86_400_000;
    return Math.round(diff);
}
